<template>
  <div>
    <!-- 状態文言 -->
    <provisioning-status @refresh="callApis" />
    <v-card class="main-card mb-3">
      <!-- タイトル -->
      <v-card-title class="screen-title">
        <span>アプライアンスオブジェクト一覧</span>
        <manual-button path="/ip-pool-list/" />
      </v-card-title>

      <!-- アプライアンスオブジェクト設定：一覧 -->
      <v-card-text class="pa-2" v-if="isLoaded">
        <div class="d-flex flex-row justify-end mb-2">
          <v-btn color="primary" @click="reload">一覧更新</v-btn>
        </div>
        <app-table
          v-model:table-sort-by="applianceObjectTable.sortBy"
          primary-key="_id"
          :sort-null-last="true"
          :fields="applianceObjectTable.fields"
          :items="applianceObjectTable.items"
          :hover="true"
          @click:row="setSelectedItem"
          :tr-class="rowHighlight"
        >
          <!-- 回線番号 -->
          <template #cell(lineNumber)="data">
            {{ $filter.emptyTo(data.value, "-") }}
          </template>
          <!-- Type4ID -->
          <template #cell(type4Id)="data">
            {{ $filter.emptyTo(data.value, "-") }}
          </template>
          <!-- Type4名 -->
          <template #cell(type4Name)="data">
            {{ $filter.emptyTo(data.value, "-") }}
          </template>
          <!-- メインサイト -->
          <template #cell(mainSite)="data">
            {{ $filter.emptyTo(data.value, "-") }}
          </template>
          <!-- 状態 -->
          <template #cell(status)="data">
            {{ $filter.emptyTo(data.value, "-") }}
          </template>
        </app-table>
      </v-card-text>
    </v-card>

    <template
      v-if="
        selectedItem &&
        (selectedItem.internetType === 'TYPE1' ||
          selectedItem.internetType === 'TYPE4')
      "
    >
      <v-card class="main-card" v-show="isLoadedTabArea">
        <!-- 表タイトル部分 -->
        <template v-if="selectedItem.internetType === 'TYPE4'">
          <v-card-title class="screen-title">
            <v-row>
              <span> インターネットType4 </span>
              <span class="ml-3"> {{ selectedItem.type4Id }} </span>
              <span class="ml-3"> {{ selectedItem.type4Name }} </span>
            </v-row>
          </v-card-title>
        </template>
        <template v-if="selectedItem.internetType === 'TYPE1'">
          <v-card-title class="screen-title">
            <span> インターネットType1 </span>
          </v-card-title>
        </template>
        <!-- タブ部分 -->
        <v-tabs
          v-model="tabIdx"
          grow
          hide-slider
          @update:modelValue="alertClear"
        >
          <v-tab text="IP Pool" :value="1"></v-tab>
          <v-tab text="IPマッピング" :value="2"></v-tab>
          <v-tab text="プロファイル" :value="3"></v-tab>
          <v-tab text="個別サービス" :value="4"></v-tab>
        </v-tabs>
        <!--        タブを移動すると画面上部に戻ってしまうので、min-heightを指定-->
        <v-tabs-window v-model="tabIdx" style="min-height: 60vh">
          <!-- IP Pool一覧 -->
          <v-tabs-window-item :value="1">
            <v-card-text class="pa-2">
              <v-row no-gutters>
                <v-col>
                  <app-search :search="ipPool.search" v-model="ipPool.filter" />
                </v-col>
                <div class="d-flex flex-row ga-1 flex-wrap ml-2">
                  <v-btn
                    v-permission.config
                    color="primary"
                    @click="showIpPoolRegister"
                    >追加</v-btn
                  >
                  <v-btn
                    v-permission.config
                    color="primary"
                    @click="deleteIpPool"
                    >削除</v-btn
                  >
                </div>
              </v-row>
              <v-alert
                v-if="!!ipPoolAlertMsg"
                class="my-2"
                :text="ipPoolAlertMsg"
              />
              <div class="d-flex flex-row justify-end mb-2">
                <v-btn color="primary" @click="getIpPoolList">一覧更新</v-btn>
              </div>
              <app-table
                v-model:table-sort-by="ipPool.sortBy"
                :sort-null-last="true"
                :fields="ipPool.fields"
                :items="ipPool.items"
                :filter="ipPool.filter"
                :filter-option="ipPool.filter_option"
                :selectable="selectable"
                primary-key="ipPoolSeq"
                :hover="true"
                @click:row="showIpPoolReference"
                :td-class="cellClass"
                sticky-header="50vh"
              >
                <template #cell(_selected)="data">
                  <v-checkbox-btn
                    v-if="!data.item.isPolicyInUse"
                    v-permission.config
                    :value="data.item"
                    v-model="ipPool.selected"
                    @click.stop
                  />
                </template>
                <template #cell(description)="data">
                  {{ $filter.emptyTo(data.value, "-") }}
                </template>
                <template #cell(isPolicyInUse)="data">
                  {{ $filter.enumTo(data.value, "isPolicyInUse") }}
                </template>
              </app-table>
            </v-card-text>
          </v-tabs-window-item>
          <!-- IPマッピング一覧 -->
          <v-tabs-window-item :value="2">
            <template v-if="isLoadedTabArea">
              <type1-ip-mapping
                ref="ipMap"
                v-if="selectedItem.internetType === 'TYPE1'"
                @reload="callApis"
              />
              <type4-ip-mapping
                ref="ipMap"
                v-if="selectedItem.internetType === 'TYPE4'"
                :type4-id="selectedItem.type4Id!"
                @reload="callApis"
              />
            </template>
          </v-tabs-window-item>

          <!-- プロファイル一覧(インターネットFW) -->
          <v-tabs-window-item :value="3">
            <v-card>
              <v-tabs v-model="profileTabIdx" grow hide-slider>
                <v-tab text="インターネットFW" :value="1"></v-tab>
                <v-tab text="URLフィルタリング" :value="2"></v-tab>
              </v-tabs>
              <v-tabs-window v-model="profileTabIdx">
                <v-tabs-window-item :value="1">
                  <v-row no-gutters>
                    <v-col>
                      <app-search
                        :search="internetFwTable.search"
                        v-model="internetFwTable.filter"
                      />
                    </v-col>
                    <div class="d-flex flex-row ga-1 flex-wrap ml-2">
                      <v-btn
                        v-permission.config
                        color="primary"
                        @click="showInternetFwRegister"
                        >追加</v-btn
                      >
                    </div>
                  </v-row>
                  <div class="d-flex flex-row justify-end mb-2">
                    <v-btn color="primary" @click="getProfileInternetFw"
                      >一覧更新</v-btn
                    >
                  </div>

                  <app-table
                    v-model:table-sort-by="internetFwTable.sortBy"
                    :fields="internetFwTable.fields"
                    :items="internetFwTable.items"
                    :filter="internetFwTable.filter"
                    :filter-option="internetFwTable.filter_option"
                    primary-key="profileInternetFwSeq"
                    :hover="true"
                    @click:row="showInternetFwReference"
                    sticky-header="50vh"
                  >
                    <template #cell(isPolicyInUse)="data">
                      {{ $filter.enumTo(data.value, "isPolicyInUse") }}
                    </template>
                  </app-table>
                </v-tabs-window-item>

                <!-- プロファイル一覧(URLフィルタリング) -->
                <v-tabs-window-item :value="2">
                  <v-row no-gutters>
                    <v-col>
                      <app-search
                        :search="urlFilteringTable.search"
                        v-model="urlFilteringTable.filter"
                      />
                    </v-col>
                    <div class="d-flex flex-row ga-1 flex-wrap ml-2">
                      <v-btn
                        color="primary"
                        v-permission.config
                        @click="showUrlFilteringRegister"
                        >追加</v-btn
                      >
                    </div>
                  </v-row>
                  <div class="d-flex flex-row justify-end mb-2">
                    <v-btn color="primary" @click="getProfileUrlFiltering"
                      >一覧更新</v-btn
                    >
                  </div>
                  <app-table
                    v-model:table-sort-by="urlFilteringTable.sortBy"
                    :fields="urlFilteringTable.fields"
                    :items="urlFilteringTable.items"
                    :filter="urlFilteringTable.filter"
                    :filter-option="urlFilteringTable.filter_option"
                    primary-key="profileUrlSeq"
                    :hover="true"
                    :sort-null-last="true"
                    @click:row="showUrlFilteringReference"
                    :td-class="cellClass"
                    sticky-header="50vh"
                  >
                    <template #cell(description)="data">
                      {{ $filter.emptyTo(data.value, "-") }}
                    </template>
                    <template #cell(isPolicyInUse)="data">
                      {{ $filter.enumTo(data.value, "isPolicyInUse") }}
                    </template>
                  </app-table>
                </v-tabs-window-item>
              </v-tabs-window>
            </v-card>
          </v-tabs-window-item>

          <!-- 個別サービス(インターネット) -->
          <v-tabs-window-item :value="4">
            <v-card-text class="pa-2">
              <v-row no-gutters>
                <v-col>
                  <app-search
                    :search="serviceSetting.search"
                    v-model="serviceSetting.filter"
                  />
                </v-col>
                <div class="d-flex flex-row ga-1 flex-wrap ml-2">
                  <v-btn
                    v-permission.config
                    color="primary"
                    @click="showServiceSettingRegister"
                    >追加</v-btn
                  >
                  <v-btn
                    v-permission.config
                    color="primary"
                    @click="deleteServiceSetting"
                    >削除</v-btn
                  >
                </div>
              </v-row>
              <v-alert
                v-if="!!serviceAlertMsg"
                class="my-2"
                :text="serviceAlertMsg"
              />
              <div class="d-flex flex-row justify-end mb-2">
                <v-btn color="primary" @click="getServiceSetting"
                  >一覧更新
                </v-btn>
              </div>
              <app-table
                v-model:table-sort-by="serviceSetting.sortBy"
                :sort-null-last="true"
                :fields="serviceSetting.fields"
                :items="serviceSetting.items"
                :filter="serviceSetting.filter"
                :filter-option="serviceSetting.filter_option"
                :selectable="selectable"
                v-model="serviceSetting.selected"
                primary-key="customServiceSeq"
                :hover="true"
                @click:row="showServiceSettingReference"
                :td-class="cellClass"
                sticky-header="50vh"
              >
                <template #cell(_selected)="data">
                  <v-checkbox-btn
                    v-if="!data.item.isPolicyInUse"
                    v-permission.config
                    :value="data.item"
                    v-model="serviceSetting.selected"
                    @click.stop
                  />
                </template>
                <template #cell(description)="data">
                  {{ $filter.emptyTo(data.value, "-") }}
                </template>
                <template #cell(isPolicyInUse)="data">
                  {{ $filter.enumTo(data.value, "isPolicyInUse") }}
                </template>
              </app-table>
            </v-card-text>
          </v-tabs-window-item>
        </v-tabs-window>
      </v-card>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type {
  AppTableHeader,
  FilterOption,
  SortItem,
} from "@/components/AppTable.vue";
import type { ApplianceInfo } from "@/apis/ContractApi";

import type { IpPool, IpPoolDelete } from "@/apis/IpPoolApi";
import IpPoolReference from "@/modals/applianceObject/IpPoolReference.vue";
import IpPoolEdit from "@/modals/applianceObject/IpPoolEdit.vue";

import ProfileInternetFwEdit from "@/modals/applianceObject/ProfileInternetFwEdit.vue";
import ProfileUrlFilteringEdit from "@/modals/applianceObject/ProfileUrlFilteringEdit.vue";
import ProfileInternetFwReference from "@/modals/applianceObject/ProfileInternetFwReference.vue";
import ProfileUrlFilteringReference from "@/modals/applianceObject/ProfileUrlFilteringReference.vue";
import type { InternetFwProfile, UrlFilteringProfile } from "@/apis/ProfileApi";

import ServiceSettingReference from "@/modals/applianceObject/ServiceSettingReference.vue";
import ServiceSettingEdit from "@/modals/applianceObject/ServiceSettingEdit.vue";
import type {
  CustomServiceDelete,
  CustomServiceInfo,
} from "@/apis/CustomServiceApi";
import enumTo from "@/filters/enum-to.filter";
import applianceTypeTo from "@/filters/appliance-type-to.filter";
import internetStatusTo from "@/filters/internet-status-to.filter";
import Type4IpMapping from "@/views/nwSetting/applianceObject/Type4IpMapping.vue";
import Type1IpMapping from "@/views/nwSetting/applianceObject/Type1IpMapping.vue";
import type { SearchOption } from "@/components/AppSearch.vue";

/**
 * contractSeqは主キーではないため別途主キー相当のプロパティを用意
 * type1、type4、イントラネットで分類してtype4は複数あるのでtype4Idで区別する
 */
export type ApplianceInfoWithId = ApplianceInfo & { _id: string };

export default defineComponent({
  name: "ApplianceObjectList",
  components: { Type1IpMapping, Type4IpMapping },
  data() {
    return {
      isLoaded: false,
      isLoadedTabArea: false,
      selectedItem: null as ApplianceInfoWithId | null | undefined,
      applianceObjectTable: {
        sortBy: { key: "lineNumber", order: "asc" } as SortItem,
        fields: applianceObjectListFields as AppTableHeader<ApplianceInfo>[],
        items: [] as ApplianceInfo[],
      },
      ipPoolAlertMsg: "",
      ipPool: {
        sortBy: { key: "ipPoolName", order: "asc" } as SortItem,
        fields: ipPoolListFields as AppTableHeader<IpPool>[],
        items: [] as IpPool[],
        selected: [],
        search: {
          ipPoolName: { type: "text", label: "名前" },
          globalIpAddress: {
            type: "text",
            label: "グローバルIP",
            width: "200px",
          },
        } as SearchOption,
        filter: {} as Record<string, unknown>,
        filter_option: {
          ipPoolName: "like",
          globalIpAddress: "like",
        } as FilterOption,
      },
      ipPoolKeyId: "",
      internetFwTable: {
        sortBy: {
          key: "profileInternetFwName",
          order: "asc",
        } as SortItem,
        fields: [
          { key: "profileInternetFwName", title: "名前", sortable: true },
          {
            key: "isPolicyInUse",
            title: "ポリシー使用有無",
            width: "400px",
            sortable: true,
          },
        ] as AppTableHeader<InternetFwProfile>[],
        items: [] as InternetFwProfile[],
        search: {
          profileInternetFwName: { type: "text", label: "名前" },
        } as SearchOption,
        filter: {} as Record<string, unknown>,
        filter_option: {
          profileInternetFwName: "like",
        } as FilterOption,
      },
      profileInternetFwKeyId: "",
      urlFilteringTable: {
        sortBy: {
          key: "profileUrlName",
          order: "asc",
        } as SortItem,
        fields: [
          { key: "profileUrlName", title: "名前", sortable: true },
          {
            key: "description",
            title: "備考",
            width: "200px",
            sortable: true,
          },
          {
            key: "isPolicyInUse",
            title: "ポリシー使用有無",
            width: "170px",
            sortable: true,
          },
        ] as AppTableHeader<UrlFilteringProfile>[],
        items: [] as UrlFilteringProfile[],
        search: {
          profileUrlName: { type: "text", label: "名前" },
        } as SearchOption,
        filter: {} as Record<string, unknown>,
        filter_option: {
          profileUrlName: "like",
        } as FilterOption,
      },
      profileUrlKeyId: "",
      serviceAlertMsg: "",
      customServiceKeyId: "",
      serviceSetting: {
        sortBy: {
          key: "serviceName",
          order: "asc",
        } as SortItem,
        fields: serviceSettingListFields as AppTableHeader<CustomServiceInfo>[],
        items: [] as CustomServiceInfo[],
        selected: [],
        search: {
          serviceName: { type: "text", label: "名前" },
          portNumber: { type: "text", label: "Port" },
        } as SearchOption,
        filter: {} as Record<string, unknown>,
        filter_option: {
          serviceName: "like",
          portNumber: "like",
        } as FilterOption,
      },
      intraCustomServiceKeyId: "",
      tabIdx: 1,
      profileTabIdx: 1,
    };
  },
  computed: {
    /** true: 一覧選択可能, false: 不可 */
    selectable(): boolean {
      return this.$service.permission.hasAuthority("CONFIG");
    },
  },
  async mounted() {
    await this.load();
    this.isLoaded = true;
  },
  methods: {
    async load() {
      // アプライアンス一覧の取得APIを呼び出し、データ取得を行う
      this.applianceObjectTable.items = (
        await this.$api.contract.getAppliances()
      ).applianceInfoList
        // イントラネットは別の画面
        .filter((e: ApplianceInfo) => e.internetType !== "INTRANET")
        .map((e: ApplianceInfo) => {
          // テーブルの主キー相当を生成
          switch (e.internetType) {
            case "TYPE1":
              return { ...e, _id: "type1" };
            case "TYPE4":
              return { ...e, _id: `type4_${e.type4Id}` };
            case "INTRANET":
              throw new Error("filtered INTRANET");
          }
        });
    },
    /** 一覧更新 */
    async reload() {
      await this.load();
      if (this.selectedItem) {
        const selectedRow = (
          this.applianceObjectTable.items as (ApplianceInfo & { _id: string })[]
        ).find((v) => v._id === this.selectedItem?._id);

        if (selectedRow) {
          await this.setSelectedItem(selectedRow);
        } else {
          this.isLoadedTabArea = false;
          this.selectedItem = null;
        }
      }
    },

    /** 選択した行のデータをセットする */
    async setSelectedItem(row: ApplianceInfoWithId) {
      this.selectedItem = row;
      // 別の契約が選択された際に、テーブルの検索状態が残らないようクリアする
      this.clearFilter();
      // 別の契約が選択された際に、アクティブなタブを初期の状態に戻す
      if (this.tabIdx !== 1) this.tabIdx = 1;
      if (this.profileTabIdx !== 1) this.profileTabIdx = 1;
      await this.callApis();
      await this.alertClear();
    },
    /** テーブルの検索状態のクリア */
    clearFilter() {
      this.ipPool.filter = {};
      this.internetFwTable.filter = {};
      this.urlFilteringTable.filter = {};
      this.serviceSetting.filter = {};
    },
    /** 選択した行の背景色を変更する処理 */
    rowHighlight(item: ApplianceInfoWithId): string[] | undefined {
      if (item._id === this.selectedItem?._id) {
        return ["table-success", "clickable"];
      }
      return ["clickable"];
    },
    /** タブエリアの情報を取得する */
    async callApis(): Promise<void> {
      // 情報の再取得を行う際に一度タブエリアを非表示にする
      if (this.isLoadedTabArea) this.isLoadedTabArea = false;

      // IP Pool取得のAPIを呼び出す
      await this.getIpPoolList();

      // プロファイル取得APIを呼び出す
      await this.getProfileInternetFw();
      await this.getProfileUrlFiltering();

      // 個別サービス取得APIを呼び出す
      await this.getServiceSetting();
      this.isLoadedTabArea = true;
    },

    /** IP Poolのデータを取得する */
    async getIpPoolList(): Promise<void> {
      // 選択された行のインターネットタイプにより呼ぶAPIを変える
      if (this.selectedItem?.internetType === "TYPE1") {
        // IP Pool(Type1)のデータをAPIから取得する
        const res = await this.$api.ipPool.getIpPoolType1();
        this.ipPool.items = res.ipPoolList;
        this.ipPoolKeyId = res.ipPoolKeyId;
      } else if (this.selectedItem?.internetType === "TYPE4") {
        // IP Pool(Type4)のデータをAPIから取得する
        const res = await this.$api.ipPool.getIpPoolType4(
          this.selectedItem.type4Id
        );
        this.ipPool.items = res.ipPoolList;
        this.ipPoolKeyId = res.ipPoolKeyId;
      }

      // チェックボックスの状態はデータを再取得しても残るので、ここでクリアしておく
      if (this.ipPool.selected.length) this.ipPool.selected = [];
    },
    /**
     * IP Pool参照モーダルを表示する
     * @param row テーブルで選択された行データ
     */
    async showIpPoolReference(row: IpPool): Promise<void> {
      this.ipPoolAlertMsg = "";
      await this.$modal.show(IpPoolReference, {
        ipPool: row,
        ipPoolKeyId: this.ipPoolKeyId,
        type4Id: this.selectedItem!.type4Id,
      });
      // 各タブの情報を再取得する
      await this.callApis();
    },
    /**
     * IP Pool追加モーダルを表示する
     */
    async showIpPoolRegister(): Promise<void> {
      this.ipPoolAlertMsg = "";
      await this.$modal.show(IpPoolEdit, {
        ipPoolKeyId: this.ipPoolKeyId,
        type4Id: this.selectedItem!.type4Id,
      });
      // 各タブの情報を再取得する
      await this.callApis();
    },
    /**
     * IP Pool削除確認モーダルを表示する
     */
    async deleteIpPool(): Promise<void> {
      // IP Poolの削除が可能か判定を行う
      if (!this.canDeleteIpPool()) return;

      // 確認ダイアログの表示
      await this.$confirm(
        `IP Poolを${this.ipPool.selected.length}件削除します。よろしいですか？`
      );

      // リクエスト用データの作成
      const reqData: IpPoolDelete = {
        ipPoolList: this.ipPool.selected.map((e: IpPool) => e.ipPoolSeq),
        note: null,
        ipPoolKeyId: this.ipPoolKeyId,
      };

      // IP Pool削除API呼び出す
      if (this.selectedItem?.internetType === "TYPE1") {
        await this.$api.ipPool.deleteIpPoolType1(reqData);
      } else if (this.selectedItem?.internetType === "TYPE4") {
        await this.$api.ipPool.deleteIpPoolType4(
          reqData,
          this.selectedItem!.type4Id
        );
      }
      // 各タブの情報を再取得する
      await this.callApis();
    },
    /** IP Poolが削除可能であるか判定を行う */
    canDeleteIpPool(): boolean {
      // チェックボックスが選択1つも選択されていない場合、アラート表示して処理終了
      if (this.ipPool.selected.length <= 0) {
        // アラートを表示する
        this.ipPoolAlertMsg = this.$filter.message("no_select_data");
        return false;
      } else {
        // アラートを非表示にする
        this.ipPoolAlertMsg = "";
      }
      return true;
    },

    /** プロファイル情報の取得(インターネットFW) */
    async getProfileInternetFw() {
      // 選択された行のインターネットタイプにより呼ぶAPIを変える
      if (this.selectedItem?.internetType === "TYPE1") {
        // プロファイルインターネットFW(Type1)のデータをAPIから取得する
        const res = await this.$api.profileApi.getType1Profile();
        this.internetFwTable.items = res.profileList;
        this.profileInternetFwKeyId = res.profileInternetFwKeyId;
      } else if (this.selectedItem?.internetType === "TYPE4") {
        // プロファイルインターネット(Type4)のデータをAPIから取得する
        const res = await this.$api.profileApi.getType4Profile(
          this.selectedItem.type4Id
        );
        this.internetFwTable.items = res.profileList;
        this.profileInternetFwKeyId = res.profileInternetFwKeyId;
      }
    },

    /** インターネットFWを追加 */
    async showInternetFwRegister() {
      await this.$modal.show(ProfileInternetFwEdit, {
        type4Id: this.selectedItem!.type4Id,
        profileInternetFwKeyId: this.profileInternetFwKeyId,
      });
      await this.callApis();
    },

    /** インターネットFWを参照 参照画面から編集画面へ遷移 削除も参照画面から */
    async showInternetFwReference(entity: InternetFwProfile) {
      await this.$modal.show(ProfileInternetFwReference, {
        profileInternetFwSeq: entity.profileInternetFwSeq,
        type4Id: this.selectedItem!.type4Id,
      });
      await this.callApis();
    },

    /** プロファイル情報の取得(URLフィルタリング) */
    async getProfileUrlFiltering() {
      // 選択された行のインターネットタイプにより呼ぶAPIを変える
      if (this.selectedItem?.internetType === "TYPE1") {
        // プロファイルURLフィルタリング(Type1)のデータをAPIから取得する
        const res = await this.$api.profileApi.getType1UrlProfile();
        this.urlFilteringTable.items = res.profileList;
        this.profileUrlKeyId = res.profileUrlKeyId;
      } else if (this.selectedItem?.internetType === "TYPE4") {
        // プロファイルURLフィルタリング(Type4)のデータをAPIから取得する
        const res = await this.$api.profileApi.getType4UrlProfile(
          this.selectedItem?.type4Id
        );
        this.urlFilteringTable.items = res.profileList;
        this.profileUrlKeyId = res.profileUrlKeyId;
      }
    },

    /** URLフィルタリングを追加 */
    async showUrlFilteringRegister() {
      await this.$modal.show(ProfileUrlFilteringEdit, {
        type4Id: this.selectedItem?.type4Id,
        profileUrlKeyId: this.profileUrlKeyId,
      });
      await this.callApis();
    },

    /** URLフィルタリングを編集 */
    async showUrlFilteringReference(entity: UrlFilteringProfile) {
      await this.$modal.show(ProfileUrlFilteringReference, {
        profileUrlSeq: entity.profileUrlSeq,
        type4Id: this.selectedItem?.type4Id,
      });
      await this.callApis();
    },

    /** 個別サービス一覧を取得する */
    async getServiceSetting(): Promise<void> {
      // 選択された行のインターネットタイプにより呼ぶAPIを変える
      if (this.selectedItem?.internetType === "TYPE1") {
        // サービス設定(Type1)のデータをAPIから取得する
        const res = await this.$api.customServiceApi.getType1CustomService();
        this.serviceSetting.items = res.customServiceList;
        this.customServiceKeyId = res.customServiceKeyId;
      } else if (this.selectedItem?.internetType === "TYPE4") {
        // サービス設定(Type4)のデータをAPIから取得する
        const res = await this.$api.customServiceApi.getType4CustomService(
          this.selectedItem.type4Id
        );
        this.serviceSetting.items = res.customServiceList;
        this.customServiceKeyId = res.customServiceKeyId;
      }

      // チェックボックスの状態はデータを再取得しても残るので、ここでクリアしておく
      if (this.serviceSetting.selected.length) {
        this.serviceSetting.selected = [];
      }
    },
    /**
     * サービス設定参照モーダルを表示する
     * @param row 選択した行のデータ
     */
    async showServiceSettingReference(row: CustomServiceInfo) {
      this.serviceAlertMsg = "";
      await this.$modal.show(ServiceSettingReference, {
        serviceSetting: row,
        customServiceKeyId: this.customServiceKeyId,
        type4Id: this.selectedItem!.type4Id,
      });
      // 各タブの情報を再取得する
      await this.callApis();
    },
    /**
     * サービス設定登録モーダルを表示する
     */
    async showServiceSettingRegister() {
      this.serviceAlertMsg = "";
      await this.$modal.show(ServiceSettingEdit, {
        customServiceKeyId: this.customServiceKeyId,
        type4Id: this.selectedItem!.type4Id,
      });
      // 各タブの情報を再取得する
      await this.callApis();
    },
    /**
     * サービス設定の一括削除処理
     */
    async deleteServiceSetting(): Promise<void> {
      // チェックボックスが選択1つも選択されていない場合、アラート表示して処理終了
      if (this.serviceSetting.selected.length <= 0) {
        // アラートを表示する
        this.serviceAlertMsg = this.$filter.message("no_select_data");
        return;
      } else {
        // アラートを非表示にする
        this.serviceAlertMsg = "";
      }

      // 削除確認ダイアログを削除件数とともに表示する
      await this.$confirm(
        `個別サービスを${this.serviceSetting.selected.length}件削除します。よろしいですか？`
      );

      // リクエスト用データの作成
      const reqData: CustomServiceDelete = {
        customServiceSeqList: this.serviceSetting.selected.map(
          (e: CustomServiceInfo) => e.customServiceSeq
        ),
        customServiceKeyId: this.customServiceKeyId,
      };

      // 個別サービス削除API呼び出す
      if (this.selectedItem?.internetType === "TYPE1") {
        await this.$api.customServiceApi.deleteType1CustomService(reqData);
      } else if (this.selectedItem?.internetType === "TYPE4") {
        await this.$api.customServiceApi.deleteType4CustomService(
          this.selectedItem.type4Id,
          reqData
        );
      }
      // 各タブの情報を再取得する
      await this.callApis();
    },

    /** エラーメッセージを初期化する */
    async alertClear() {
      if (this.$refs.ipMap) {
        await (this.$refs.ipMap as { alertClear: () => void }).alertClear();
      }
      this.ipPoolAlertMsg = "";
      this.serviceAlertMsg = "";
    },

    /** tdにクラスをつける */
    cellClass(field: AppTableHeader<unknown>): string[] | undefined {
      if (field.key === "description") {
        return ["text-pre-wrap"];
      }
      return undefined;
    },
  },
});

/** 列のデータ(アプライアンスオブジェクト一覧) */
const applianceObjectListFields = [
  {
    key: "lineNumber",
    title: "回線番号",
    width: "200px",
    sortable: true,
    sortByFormatted: true,
    filterByFormatted: false,
    formatter: (value: null, key: null, item: ApplianceInfo) => {
      return item.internetType === "TYPE1"
        ? item.enumberMainAct + " " + item.enumberMainSby
        : item.internetType === "TYPE4"
          ? item.wnumberMainAct + " " + item.wnumberMainSby
          : null;
    },
  },
  { key: "vpnVnCode", title: "VPN/VNコード", sortable: true },
  {
    key: "internetType",
    title: "Type",
    sortable: true,
    sortByFormatted: true,
    filterByFormatted: false,
    formatter: (value: string) => {
      return enumTo(value, "internetType");
    },
  },
  {
    key: "type4Id",
    title: "Type4ID",
    sortable: true,
  },
  {
    key: "type4Name",
    title: "Type4名",
    sortable: true,
  },
  {
    key: "mainSite",
    title: "メインサイト",
    sortable: true,
    sortByFormatted: true,
    filterByFormatted: false,
    formatter: (value: string) => {
      return value ? enumTo(value, "mainSite") : null;
    },
  },
  {
    key: "appliance",
    title: "アプライアンス",
    sortable: true,
    sortByFormatted: true,
    filterByFormatted: false,
    formatter: (value: null, key: null, item: ApplianceInfo) => {
      return applianceTypeTo(item.applianceType, item.bandwidth);
    },
  },
  {
    key: "status",
    title: "状態",
    sortable: true,
    sortByFormatted: true,
    filterByFormatted: false,
    formatter: (value: null, key: null, item: ApplianceInfo) => {
      return internetStatusTo(item.isStart, item.isInternetPause) === "-"
        ? null
        : internetStatusTo(item.isStart, item.isInternetPause);
    },
  },
];

/** 列のデータ(IP Pool) */
const ipPoolListFields = [
  { key: "ipPoolName", title: "名前", width: "250px", sortable: true },
  {
    key: "globalIpAddress",
    title: "グローバルIP",
    width: "200px",
    sortable: true,
  },
  {
    key: "description",
    title: "備考",
    width: "200px",
    sortable: true,
  },
  {
    key: "isPolicyInUse",
    title: "ポリシー使用有無",
    width: "170px",
    sortable: true,
  },
];

/** 列のデータ(個別サービス) */
const serviceSettingListFields = [
  { key: "serviceName", title: "名前", sortable: true },
  { key: "protocol", title: "プロトコル", width: "160px", sortable: true },
  { key: "portNumber", title: "Port", sortable: true },
  {
    key: "description",
    width: "200px",
    title: "備考",
    sortable: true,
  },
  {
    key: "isPolicyInUse",
    title: "ポリシー使用有無",
    width: "170px",
    sortable: true,
  },
];
</script>
